import styled from 'styled-components';

export const Icon = styled.span`
  color: var(--main-color);
`;
